import { apiget, apipost, apiput, apidel } from "../../api";

export const types = {
  GET_PARTNERS: "GET_PARTNERS",
  SEARCH_PARTNER: "SEARCH_PARTNER",
  ADD_PARTNER: "ADD_PARTNER",
  UPDATE_PARTNER: "UPDATE_PARTNER",
  ASK_NEW_PARTNER: "ASK_NEW_PARTNER",
  GET_PARTNER_BY_ID: "GET_PARTNER_BY_ID",
  GET_PARTNER_BY_UUID: "GET_PARTNER_BY_UUID",
  GET_PARTNER_BY_UUID_D: "GET_PARTNER_BY_UUID_D",
  DELETE_PARTNER: "DELETE_PARTNER"
};

export const additions = {
  CONTACTS: "contacts",
  PROJECTS: "projects",
  PROJECTS_SUMMARY: "projects_summary"
};

export const sortmodes = {
  BY_ID: "id",
  BY_NAME: "name",
  BY_EMPLOYEES: "contacts.length"
};

export const actions = {
  [types.GET_PARTNERS]: token => async (_, appends) =>
    await apiget(`/partners`, { appends }, token),
  [types.SEARCH_PARTNER]: token => async (_, { query }) =>
    await apiget(`/partners/search/${query}`, {}, token),
  [types.ADD_PARTNER]: token => async (_, { name }) =>
    await apipost(`/partners`, { name }, token),
  [types.GET_PARTNER_BY_ID]: token => async (_, { id }) =>
    await apiget(`/partner/${id}`, {}, token),
  [types.GET_PARTNER_BY_UUID]: token => async (_, { uuid, appends = null }) =>
    await apiget(`/partner/${uuid}`, { appends }, token),
  [types.GET_PARTNER_BY_UUID_D]: token => async (_, { uuid }) =>
    await apiget(`/partner_d/${uuid}`, {}, token),
  [types.ASK_NEW_PARTNER]: token => async (_, name) =>
    await apipost("/partners", name ? { name } : {}, token),
  [types.UPDATE_PARTNER]: token => async (_, partner) =>
    await apiput(`/partner/${partner.uuid}`, partner, token),
  [types.DELETE_PARTNER]: token => async (_, identifier) =>
    await apidel(`/partner/${identifier}`, {}, token)
};
